<template>
  <div class="data-analysis-page">
    <a-form layout="inline" class="search-form">
      <a-form-item label="用户：">
        <UserSelect
          v-model="form.userCode"
          @change="onUserSelectChange"
        />
      </a-form-item>
      <a-form-item label="水表编号：">
        <a-input v-model="form.meterNo" allow-clear style="width: 150px"  />
      </a-form-item>
      <a-form-item label="表册分组：">
        <a-select v-model="form.groupId" style="width: 150px" @change="onGroupChange" allow-clear >
          <a-select-option v-for="item in groupList" :key="item.id" :value="item.id">{{ item.groupName }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="表册：">
        <a-select 
          v-model="form.bookId" 
          style="width: 150px" 
          placeholder="请选择" 
          allow-clear 
          show-search
          :filter-option="filterMeterBookOption"
        >
          <a-select-option v-for="item in meterBooksList" :key="item.id" :value="item.id">{{ item.bookName }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <div class="time-bar">
      <span>时长：</span>
      <a-button type="primary" :ghost="form.duration !== 'month'" @click="setDuration('month')">月份</a-button>
      <!-- <a-button type="primary" :ghost="form.duration !== 'quarter'" @click="setDuration('quarter')">季度</a-button> -->
      <!-- <a-button type="primary" :ghost="form.duration !== 'year'" @click="setDuration('year')"> 年份 </a-button> -->
    </div>
    <div class="indicator-bar">
      <span>指标：</span>
      <a-button type="primary" :ghost="form.indicator !== '用水量'" @click="form.indicator = '用水量'">用水量</a-button>
      <!-- <div class="chart-options">
        <a-checkbox
          v-model="showDataLabels"
          @change="onDataLabelsChange"
          style="margin-left: 20px;"
        >
          显示数据标签
        </a-checkbox>
        <a-button
          type="link"
          size="small"
          @click="toggleChartType"
          style="margin-left: 10px;"
        >
          {{ chartType === 'line' ? '切换为柱状图' : '切换为折线图' }}
        </a-button>
      </div> -->
    </div>
   
    <div class="date-bar">
      <div class="time-row">
        <span class="time-label">查询时间：</span>
        <el-date-picker
          v-if="form.duration === 'month'"
          v-model="mainTimeRange"
          type="monthrange"
          range-separator=" - "
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="handleMainChange"
          style="width: 260px"
        />
        <el-date-picker
          v-else-if="form.duration === 'year' || form.duration === 'quarter'"
          v-model="mainTimeRange"
          type="daterange"
          range-separator="-"
          start-placeholder="开始年份"
          end-placeholder="结束年份"
          format="yyyy"
          value-format="yyyy"
          :picker-options="yearPickerOptions"
          @change="handleMainChange"
          style="width: 260px"
        />
        <a-button type="primary" style="margin-left: 20px;" @click="onQuery">查询</a-button>
      </div>
      <div class="time-row">
        <span class="time-label">对比时间：</span>
        <el-date-picker
          v-if="form.duration === 'month'"
          v-model="compareTimeRange"
          type="monthrange"
          range-separator="-"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="handleCompareChange"
          style="width: 260px"
        />
        <el-date-picker
          v-else-if="form.duration === 'year' || form.duration === 'quarter'"
          v-model="compareTimeRange"
          type="daterange"
          range-separator="-"
          start-placeholder="开始年份"
          end-placeholder="结束年份"
          format="yyyy"
          value-format="yyyy"
          :picker-options="yearPickerOptions"
          @change="handleCompareChange"
          style="width: 260px"
        />
        <a-button type="primary" style="margin-left: 20px;" @click="onQuery">对比</a-button>
      </div>
    </div>
    


    <div v-if="totalConsumption !== null" class="summary-bar" style="margin-bottom: 12px;">
      <span>总用水量：{{ totalConsumption }} m³</span>
      <span v-if="timePeriod" style="margin-left: 24px;">周期：{{ timePeriod }}</span>
    </div>

    <div class="chart-box">
      <div ref="chartRef" style="height: 500px; width: 100%;"></div>
    </div>
  </div>
</template>

<script> 
import moment from 'moment'
import 'moment/locale/zh-cn'
import { DatePicker } from 'element-ui'
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'
import * as echarts from 'echarts'

// 配置 moment
moment.locale('zh-cn')

export default {
  name: 'DataAnalysis',
  components: {
    'el-date-picker': DatePicker,
    UserSelect,
  },
  data() {
    return {
      form: {
        duration: 'month',
        timeRange: [],
        compareTimeRange: [],
        quarterRange: [],
        compareQuarterRange: [],
        userId: '',
        meterNo: '',
        groupId: '',
        bookId: '',
        indicator: '用水量',
        step: '一月',
        userList: [],
        allUserList: [], // 所有用户数据
        groupList: [],
        meterBooksList: [],
        userCode: '',
        userName: '',
        meterNumber: '',
        meterBookId: '',
      },
      endOpen:false,
      mainTimeRange: [],
      compareTimeRange: [],
      yearPickerOptions: {
        shortcuts: [{
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 3)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近五年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 5)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      userList: [],
      allUserList: [], // 所有用户数据
      groupList: [],
      meterBooksList: [],
      userLoading: false,
      chartInstance: null,
      chartOption: {
        title: { left: 'center', text: '' },
        tooltip: { trigger: 'axis' },
        legend: { data: ['用水量'], top: 30 },
        grid: { left: 60, right: 40, bottom: 60, top: 80 },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: { rotate: 0 },
            name: '查询时间',
            nameLocation: 'middle',
            nameGap: 30,
            nameTextStyle: { fontSize: 12, color: '#1890ff' }
          },
          {
            type: 'category',
            data: [],
            axisLabel: { rotate: 0 },
            name: '对比时间',
            nameLocation: 'middle',
            nameGap: 30,
            nameTextStyle: { fontSize: 12, color: '#52c41a' }
          }
        ],
        yAxis: {
          type: 'value',
          name: 'm³',
          nameTextStyle: { fontSize: 14 },
          splitLine: { lineStyle: { type: 'dashed' } }
        },
        dataZoom: [
          { type: 'slider', start: 0, end: 100, bottom: 10 }
        ],
        toolbox:{
          show: true,
          top: 30,
          magicType: { type: ['line', 'bar'] },
          feature:{
            saveAsImage:{
              name: '用水量数据分析',
            }
          }
        },
        series: []
      },
      totalConsumption: null,
      chartType: 'line',
      isDetailUser: false,
      showDataLabels: false,
      timeMapping: [], // 时间映射关系
    }
  },

  mounted() {
    const { userCode, userName } = this.$route.query || {}
    console.log(this.$route.query);
    
    if (userCode) {
      this.isDetailUser = true
      this.form.userCode = userCode
      this.getUserList()
      const end = moment()
      const start = end.clone().subtract(5, 'month')
      if (this.form.duration === 'month') {
        this.mainTimeRange = [start.format('YYYY-MM'), end.format('YYYY-MM')]
        this.form.timeRange = [start.format('YYYY-MM'), end.format('YYYY-MM')]
      } else {
        this.mainTimeRange = [start.format('YYYY'), end.format('YYYY')]
        this.form.timeRange = [start.format('YYYY'), end.format('YYYY')]
      }
      this.getGroupList()
      this.renderChart()
      this.onQuery()
      window.addEventListener('resize', this.resizeChart)
    } else {
      this.getUserList()
      this.getGroupList()
      this.renderChart()
      this.onQuery()
      window.addEventListener('resize', this.resizeChart)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chartInstance) {
      // 清理事件监听器
      this.chartInstance.off('mouseover')
      this.chartInstance.off('mouseout')
      this.chartInstance.dispose()
    }
  },
  methods: {
    renderChart() {
      try {
        if (!this.$refs.chartRef) {
          console.warn('图表容器不存在')
          return
        }
        if (!this.chartInstance) {
          this.chartInstance = echarts.init(this.$refs.chartRef)
        }
        // 使用notMerge参数完全替换配置，避免残留数据
        console.log('渲染图表配置:', this.chartOption)
        this.chartInstance.setOption(this.chartOption, true)
      } catch (e) {
        console.error('渲染图表失败:', e)
        throw e // 重新抛出错误，让上层catch处理
      }
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    getUserList() {
      // 如果有用户编码参数，设置用户名称
      if (this.form.userCode) {
        this.form.userName = this.$route.query.userName || ''
      }
      return Promise.resolve([]);
    },
    // 用户下拉本地过滤
    onUserSelectChange(value, user) {
      console.log('用户选择变化:', value, user);
      if (user) {
        this.form.userName = user.userName;
        console.log('设置用户名:', user.userName);
      } else {
        this.form.userName = '';
        console.log('清空用户名');
      }
    },
    getGroupList() {
      return this.$http.get('/meter-manager/meter_book_groups/list')
        .then(({ data }) => {
          console.log('分组接口返回:', data)
          this.groupList = data || [];
          return data;
        })
        .catch(() => {
          this.groupList = [];
          return [];
        });
    },
    getMeterBooksList(groupId = null) {
      const gid = groupId || this.form.groupId;
      if (!gid) {
        this.meterBooksList = [];
        return Promise.resolve([]);
      }
      return this.$http.get(`/meter-manager/meter_reading_plans/meter-books?groupId=${gid}`)
        .then(({ data }) => {
          console.log('表册接口返回:', data)
          this.meterBooksList = Array.isArray(data) ? data : (data.list || data.data || []);
          return this.meterBooksList;
        })
        .catch(() => {
          this.meterBooksList = [];
          return [];
        });
    },
    onGroupChange() {
      this.form.bookId = '';
      if (this.form.groupId) {
        this.getMeterBooksList(this.form.groupId);
      } else {
        this.meterBooksList = [];
      }
    },
    getQueryParams() {
      
      const params = {
        userCode: this.form.userCode,
        userName: this.form.userName,
        meterNumber: this.form.meterNumber,
        groupId: this.form.groupId,
        meterBookId: this.form.meterBookId,
        duration: this.form.duration
      }
      // 统一格式化为 YYYY-MM-DD
      const getDateRange = arr => {
        if (!arr || arr.length !== 2) return [null, null]
        return [
          moment(arr[0]).startOf('month').format('YYYY-MM-DD'),
          moment(arr[1]).endOf('month').format('YYYY-MM-DD')
        ]
      }
      if (this.mainTimeRange && this.mainTimeRange.length === 2) {
        const [start, end] = getDateRange(this.mainTimeRange)
        params.startDate = start
        params.endDate = end
      }
      if (this.compareTimeRange && this.compareTimeRange.length === 2) {
        const [cStart, cEnd] = getDateRange(this.compareTimeRange)
        params.contrastStartDate = cStart
        params.contrastEndDate = cEnd
      }
      return params
    },
    async onQuery() {
      this.executeQuery()
    },
    
    async executeQuery() {
      const params = this.getQueryParams()
      try {
        const res = await this.$http.post('/meter-manager/data_statistics', params)
        if (res.code === 0 && res.data && res.data.waterList) {
          const xData = res.data.waterList.map(i => i.timePeriod || i.date)
          const yData = res.data.waterList.map(i => i.totalConsumption || i.value)
          let contrastYData = []
          let contrastXData = []

          if (res.data.contrastWaterList && Array.isArray(res.data.contrastWaterList)) {
            contrastYData = res.data.contrastWaterList.map(i => i.totalConsumption || i.value)
            contrastXData = res.data.contrastWaterList.map(i => i.timePeriod || i.date)
          }

          // 如果有对比数据，使用查询时间轴展示，对比数据映射到相同时间轴
          if (contrastYData.length > 0 && contrastXData.length > 0) {
            console.log('有对比数据，使用查询时间轴展示');

            // 使用查询时间作为主时间轴
            this.chartOption.xAxis = [
              {
                type: 'category',
                data: xData,
                axisLabel: {
                  rotate: -15,
                  fontSize: 11,
                  formatter: function(value) {
                    // 处理过长的标签
                    if (value.length > 10) {
                      return value.substring(0, 8) + '...'
                    }
                    return value
                  }
                },
                name: '查询时间',
                nameLocation: 'middle',
                nameGap: 35,
                nameTextStyle: { fontSize: 12, color: '#1890ff' }
              }
            ]

            // 将对比数据映射到查询时间轴上
            const mappedContrastData = this.mapContrastDataToMainAxis(xData, contrastXData, contrastYData)

            // 创建时间映射关系，用于tooltip显示
            this.createTimeMapping(xData, contrastXData)

            this.chartOption.series = [
              {
                name: '查询用水量',
                type: this.chartType,
                smooth: true,
                data: yData,
                itemStyle: {
                  color: '#1890ff',
                  borderWidth: 2,
                  borderColor: '#1890ff'
                },
                lineStyle: {
                  width: 3
                },
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' }
                  ]
                },
                // 添加数据标签
                label: {
                  show: this.showDataLabels,
                  position: 'top',
                  fontSize: 10,
                  color: '#1890ff',
                  formatter: '{c} m³'
                }
              },
              {
                name: '对比用水量',
                type: this.chartType,
                smooth: true,
                data: mappedContrastData,
                itemStyle: {
                  color: '#52c41a',
                  borderWidth: 2,
                  borderColor: '#52c41a'
                },
                lineStyle: {
                  width: 3,
                  type: 'dashed' // 使用虚线区分
                },
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' }
                  ]
                },
                // 添加数据标签
                label: {
                  show: this.showDataLabels,
                  position: 'top',
                  fontSize: 10,
                  color: '#52c41a',
                  formatter: '{c} m³'
                }
              }
            ]

            this.chartOption.legend = {
              data: ['查询用水量', '对比用水量'],
              top: 30,
              right: 20,
              itemWidth: 25,
              itemHeight: 14,
              textStyle: {
                fontSize: 12
              }
            }

            // 优化tooltip显示
            this.chartOption.tooltip = {
              trigger: 'axis',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderColor: '#ccc',
              borderWidth: 1,
              textStyle: {
                color: '#333'
              },
              formatter: (params) => {
                if (params && params.length > 0) {
                  const queryTime = params[0].name // 查询时间
                  const contrastTime = this.getContrastTimeForIndex(params[0].dataIndex) // 对应的对比时间

                  let result = ''
                  let mainValue = null
                  let contrastValue = null

                  // 提取数据值
                  params.forEach(param => {
                    const value = param.value !== null && param.value !== undefined ? param.value : 0
                    if (param.seriesName === '查询用水量') {
                      mainValue = value
                    } else if (param.seriesName === '对比用水量') {
                      contrastValue = value
                    }
                  })

                  // 按指定顺序显示：查询时间，查询用水量，对比时间，对比用水量
                  result += `<div style="margin-bottom: 6px;">
                    <span style="font-weight: bold; color: #1890ff;">查询时间:</span>
                    <span style="margin-left: 6px;">${queryTime}</span>
                  </div>`

                  result += `<div style="margin-bottom: 6px;">
                    <span style="color: #1890ff;">●</span>
                    <span style="font-weight: 500; margin-left: 4px;">查询用水量:</span>
                    <span style="color: #1890ff; font-weight: bold; margin-left: 6px;">${mainValue !== null ? mainValue : 0} m³</span>
                  </div>`

                  if (contrastTime) {
                    result += `<div style="margin-bottom: 6px;">
                      <span style="font-weight: bold; color: #52c41a;">对比时间:</span>
                      <span style="margin-left: 6px;">${contrastTime}</span>
                    </div>`

                    result += `<div style="margin-bottom: 6px;">
                      <span style="color: #52c41a;">●</span>
                      <span style="font-weight: 500; margin-left: 4px;">对比用水量:</span>
                      <span style="color: #52c41a; font-weight: bold; margin-left: 6px;">${contrastValue !== null ? contrastValue : 0} m³</span>
                    </div>`
                  }

                  return result
                }
                return ''
              }
            }

            // 优化网格布局
            this.chartOption.grid = {
              left: 60,
              right: 40,
              bottom: 80,
              top: 100,
              containLabel: true
            }

          } else {
            console.log('没有对比数据');

            // 单数据展示
            this.chartOption.xAxis = [
              {
                type: 'category',
                data: xData,
                axisLabel: {
                  rotate: -15,
                  fontSize: 11
                },
                name: '查询时间',
                nameLocation: 'middle',
                nameGap: 35,
                nameTextStyle: { fontSize: 12, color: '#1890ff' }
              }
            ]

            this.chartOption.tooltip = {
              trigger: 'axis',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderColor: '#ccc',
              borderWidth: 1,
              textStyle: {
                color: '#333'
              },
              formatter: function(params) {
                if (params && params.length > 0) {
                  const param = params[0]
                  const value = param.value !== null && param.value !== undefined ? param.value : 0
                  return `<div style="font-weight: bold; margin-bottom: 4px;">${param.name}</div>
                          <div>${param.marker}<span style="font-weight: 500;">${param.seriesName}:</span>
                          <span style="color: ${param.color}; font-weight: bold;">${value} m³</span></div>`
                }
                return ''
              }
            }

            this.chartOption.legend = {
              data: ['用水量'],
              top: 30,
              right: 20
            }

            this.chartOption.series = [
              {
                name: '用水量',
                type: this.chartType,
                smooth: true,
                data: yData,
                itemStyle: {
                  color: '#1890ff',
                  borderWidth: 2,
                  borderColor: '#1890ff'
                },
                lineStyle: {
                  width: 3
                },
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' }
                  ]
                }
              }
            ]

            this.chartOption.grid = {
              left: 60,
              right: 40,
              bottom: 70,
              top: 80,
              containLabel: true
            }
          }

          this.totalConsumption = res.data.totalConsumption || null
          this.timePeriod = res.data.timePeriod || ''
          this.renderChart()
        } else {
          this.$message.error(res.message || '查询失败1')
        }
      } catch (e) {
        console.error('查询失败详细错误:', e)
        this.$message.error('查询失败2: ' + e.message)
      }
    },
    setDuration(type) {
      this.form.duration = type
      this.form.timeRange = []
      this.form.compareTimeRange = []
      this.mainTimeRange = []
      this.compareTimeRange = []
      // 重置时间范围后，清除提示信息
      this.totalConsumption = null
      this.timePeriod = ''
    },
    handleMainChange(val) {
      this.mainTimeRange = val
      this.form.timeRange = val
    },
    handleCompareChange(val) {
      this.compareTimeRange = val
      this.form.compareTimeRange = val
    },


    
    // 调整数据以匹配目标横坐标
    adjustDataToXAxis(originalXData, originalYData, targetXData) {
      if (originalXData.length === targetXData.length) {
        return originalYData
      }
      
      const adjustedData = []
      const originalDataMap = new Map()
      
      // 创建原始数据的映射
      for (let i = 0; i < originalXData.length; i++) {
        originalDataMap.set(originalXData[i], originalYData[i])
      }
      
      // 根据目标横坐标调整数据
      for (let i = 0; i < targetXData.length; i++) {
        const targetX = targetXData[i]
        if (originalDataMap.has(targetX)) {
          // 确保数值类型
          const value = originalDataMap.get(targetX)
          adjustedData.push(typeof value === 'string' ? parseFloat(value) || 0 : value || 0)
        } else {
          // 如果目标横坐标在原始数据中不存在，填充0
          adjustedData.push(0)
        }
      }
      
      return adjustedData
    },
    getFormat() {
      if (this.form.duration === 'month') return 'YYYY-MM'
      if (this.form.duration === 'year') return 'YYYY'
      return 'YYYY-MM'
    },
    getMode() {
      if (this.form.duration === 'month') return ['month', 'month']
      if (this.form.duration === 'year') return ['year', 'year']
      return ['month', 'month']
    },
    getPlaceholder() {
      if (this.form.duration === 'month') return ['开始月份', '结束月份']
      if (this.form.duration === 'year') return ['开始年份', '结束年份']
      return ['开始', '结束']
    },
    setChartType(type) {
      this.chartType = type
      this.onQuery()
    },
    exportChart() {
      if (this.chartInstance) {
        const url = this.chartInstance.getDataURL({
          type: 'png',
          pixelRatio: 2,
          backgroundColor: '#fff'
        })
        const a = document.createElement('a')
        a.href = url
        a.download = '用水量统计.png'
        a.click()
      }
    },

    // 表册搜索过滤函数
    filterMeterBookOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    
    // 将数组填充到指定长度
    padArrayToLength(array, targetLength, fillValue = null) {
      if (array.length >= targetLength) {
        return array.slice(0, targetLength)
      }
      
      const paddedArray = [...array]
      while (paddedArray.length < targetLength) {
        paddedArray.push(fillValue)
      }
      
      return paddedArray
    },
    
    // 创建统一的时间轴标签
    createCombinedLabels(mainLabels, contrastLabels) {
      // 创建所有时间标签的集合，去重并排序
      const allLabels = new Set([...mainLabels, ...contrastLabels])
      return Array.from(allLabels).sort((a, b) => {
        // 根据时间格式进行排序
        if (a.includes('-') && b.includes('-')) {
          return new Date(a + '-01').getTime() - new Date(b + '-01').getTime()
        }
        return a.localeCompare(b)
      })
    },

    // 调整数据以匹配组合的时间轴
    adjustDataForCombinedAxis(originalLabels, originalData, combinedLabels, type) {
      const result = []
      const dataMap = new Map()

      // 创建原始数据的映射
      for (let i = 0; i < originalLabels.length; i++) {
        dataMap.set(originalLabels[i], originalData[i])
      }

      // 根据组合标签调整数据
      combinedLabels.forEach(label => {
        if (dataMap.has(label)) {
          result.push(dataMap.get(label))
        } else {
          // 对于不存在的时间点，填充null（不显示数据点）
          result.push(null)
        }
      })

      return result
    },

    // 添加鼠标事件处理（保留原有功能，但现在主要用于单时间轴模式）
    addMouseEvents() {
      if (!this.chartInstance) return

      // 鼠标进入图表区域时显示第二个时间轴
      this.chartInstance.on('mouseover', () => {
        if (this.chartOption.xAxis && this.chartOption.xAxis.length > 1) {
          this.chartOption.xAxis[1].show = true
          this.chartInstance.setOption(this.chartOption, false)
        }
      })

      // 鼠标离开图表区域时隐藏第二个时间轴
      this.chartInstance.on('mouseout', () => {
        if (this.chartOption.xAxis && this.chartOption.xAxis.length > 1) {
          this.chartOption.xAxis[1].show = false
          this.chartInstance.setOption(this.chartOption, false)
        }
      })
    },

    // 切换数据标签显示
    onDataLabelsChange() {
      this.executeQuery()
    },

    // 切换图表类型
    toggleChartType() {
      this.chartType = this.chartType === 'line' ? 'bar' : 'line'
      this.executeQuery()
    },

    // 将对比数据映射到主时间轴
    mapContrastDataToMainAxis(mainTimeLabels, contrastTimeLabels, contrastData) {
      const result = []

      // 按主时间轴顺序映射对比数据
      mainTimeLabels.forEach((timeLabel, index) => {
        let mappedValue = null

        if (index < contrastData.length) {
          // 按索引顺序对应，处理跨年对比的情况
          mappedValue = contrastData[index]
        } else {
          // 如果对比数据不够，尝试根据月份匹配
          const mainMonth = this.extractMonthFromTimeLabel(timeLabel)
          for (let i = 0; i < contrastTimeLabels.length; i++) {
            const contrastMonth = this.extractMonthFromTimeLabel(contrastTimeLabels[i])
            if (mainMonth === contrastMonth) {
              mappedValue = contrastData[i]
              break
            }
          }
        }

        result.push(mappedValue)
      })

      return result
    },

    // 创建时间映射关系
    createTimeMapping(mainTimeLabels, contrastTimeLabels) {
      this.timeMapping = []

      // 为每个主时间创建映射关系
      mainTimeLabels.forEach((timeLabel, index) => {
        let contrastTime = null

        if (index < contrastTimeLabels.length) {
          // 按索引顺序对应，处理跨年对比的情况
          contrastTime = contrastTimeLabels[index]
        } else {
          // 如果对比数据不够，尝试根据月份匹配
          const mainMonth = this.extractMonthFromTimeLabel(timeLabel)
          for (let contrastLabel of contrastTimeLabels) {
            const contrastMonth = this.extractMonthFromTimeLabel(contrastLabel)
            if (mainMonth === contrastMonth) {
              contrastTime = contrastLabel
              break
            }
          }
        }

        this.timeMapping.push({
          queryTime: timeLabel,
          contrastTime: contrastTime
        })
      })
    },

    // 从时间标签中提取月份
    extractMonthFromTimeLabel(timeLabel) {
      if (typeof timeLabel === 'string' && timeLabel.includes('-')) {
        const parts = timeLabel.split('-')
        return parts[1] // 返回月份部分，如 "2025-01" 返回 "01"
      }
      return timeLabel
    },

    // 根据索引获取对应的对比时间
    getContrastTimeForIndex(dataIndex) {
      if (this.timeMapping && this.timeMapping[dataIndex]) {
        return this.timeMapping[dataIndex].contrastTime
      }
      return null
    },
  },
}
</script>

<style scoped>
.data-analysis-page {
  padding: 24px;
  background: #fff;
}
.search-form {
  margin-bottom: 12px;
}
.indicator-bar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}

.chart-options {
  display: flex;
  align-items: center;
}
.time-bar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.time-bar > button {
  /* border: 0.5px solid #d9d9d9; */
  /* 右侧负边距 */
  margin-right: -1px;  
  /* 左侧负边距 */
  margin-left: -1px; 
}

.date-bar {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.time-row {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
}

.time-label {
  font-weight: 500;
  color: #333;
  min-width: 80px;
  margin-right: 12px;
} 
.chart-box {
  background: #fff;
  padding: 12px 0 0 0;
}
</style>